import BaseIdbRepository from "../../../../../repositories/idb/BaseIdbRepository";
import { IndexedDbKeyNames, IndexedDbNames } from "../../../../../services/SystemNames";
import { isObjectNull } from "../../../../helpers/ObjectHelpers";

export interface DrawerMenuRepositoryInterface {
    setMapExpandedAsync: (obj: any) => Promise<void>,
    getMapExpandedAsync: () => Promise<any>
}

export class DrawerMenuRepository implements DrawerMenuRepositoryInterface {

    _store: string = IndexedDbNames.MetaStore;

    async setMapExpandedAsync(obj: any) {
        const id = IndexedDbKeyNames.MapExpanded;
        await BaseIdbRepository.setAsync(this._store, id, { id: id, value: obj });
    }

    async getMapExpandedAsync() {
        const id = IndexedDbKeyNames.MapExpanded;
        const obj:any = await BaseIdbRepository.getAsync(this._store, id);
        if (isObjectNull(obj)) return false;
        return obj.value;
    }
}
